import React from 'react';
import { useSelector } from 'react-redux';

export const SmsLogRowItem = ({ log }) => {
    const { colores } = useSelector(state => state.ui);
    
    const formatDate = (date) => {
        return new Date(date).toLocaleString('es-ES', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const getEstadoColor = (estado) => {
        switch (estado) {
            case 'enviado':
                return '#4CAF50';
            case 'error':
                return '#F44336';
            default:
                return colores.color4;
        }
    };

    const getEstadoEntregaColor = (estadoEntrega) => {
        switch (estadoEntrega) {
            case 'entregado':
                return '#4CAF50';
            case 'fallido':
                return '#F44336';
            case 'expirado':
                return '#FF9800';
            case 'pendiente':
                return '#2196F3';
            default:
                return colores.color4;
        }
    };

    const ETIQUETAS_TIPO_SMS = {
        confirmacion: 'Confirmación',
        recordatorio: 'Recordatorio',
        aviso: 'Aviso'
    };

    const getTipoLabel = (tipo) => ETIQUETAS_TIPO_SMS[tipo] || tipo;

    return (
        <div 
            className='table-row'
            style={{ borderBottom: `1px solid ${colores.color6}` }}
        >
            <div className='column fecha'>
                {formatDate(log.fechaEnvio)}
            </div>
            <div className='column empresa'>
                {log.empresa?.nombre || 'N/A'}
            </div>
            <div className='column telefono'>
                {log.telefono}
            </div>
            <div className='column tipo'>
                {getTipoLabel(log.tipo)}
            </div>
            <div className='column estado'>
                <span 
                    style={{ 
                        color: getEstadoColor(log.estado)
                    }}
                >
                    {log.estado.toUpperCase()}
                </span>
            </div>
            <div className='column entrega'>
                <span 
                    style={{ 
                        color: getEstadoEntregaColor(log.estadoEntrega)
                    }}
                >
                    {log.estadoEntrega?.toUpperCase() || 'PENDIENTE'}
                </span>
            </div>
            <div className='column mensaje'>
                <span 
                    title={log.mensaje}
                >
                    {log.mensaje}
                </span>
            </div>
        </div>
    );
};